import {connect} from 'react-redux'

import type {State} from '../../../reducers/types'
import {getSingleBuildArg} from '../../../rest/builds'
import {getBuildLocator} from '../../../rest/locators'
import {getOverviewHref} from '../../../routes'
import {getBuild} from '../../../selectors'
import {restApi} from '../../../services/rest'
import {getDuration} from '../../../utils/buildStats'

import BuildInfo from './BuildInfo'
import type {OwnProps, StateProps, Props} from './BuildInfo.types'

const mapStateToProps = (state: State, {buildId}: OwnProps): StateProps => {
  const build = getBuild(state, buildId)
  const {
    status = 'UNKNOWN',
    statusText = '',
    startDate,
    finishDate,
    ['running-info']: runningInfo,
    buildType: buildTypeId,
  } = build || {}
  const duration = getDuration({startDate, finishDate, runningInfo})
  const href = getOverviewHref({
    buildId,
    buildTypeId,
  })
  return {
    href,
    status,
    duration,
    startDate,
    finishDate,
    statusText,
    buildTypeId,
    left: runningInfo?.leftSeconds,
    progress: runningInfo?.percentageComplete,
    running: build?.state === 'running',
    loading: build == null || build.state === 'queued',
  }
}

function BuildInfoContainer(props: Props) {
  const {loading, withFetchBuildData, buildId} = props
  restApi.endpoints.getBuildNormalized.useQuerySubscription(
    getSingleBuildArg(getBuildLocator(buildId)),
    {skip: !withFetchBuildData},
  )
  return loading ? null : <BuildInfo {...props} />
}
export default connect(mapStateToProps)(BuildInfoContainer)
